import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/authStore";
import { toast } from "@/utils/toast";

export function useRegisterForm() {
  const auth = useAuthStore();
  const router = useRouter();
  const route = useRoute();
  const loading = ref(false);

  const submit = async (values) => {
    if (loading.value) return;
    loading.value = true;
    let keepLoading = false;

    try {
      const planId = route.query.plan_id;
      const result = await auth.register({
        ...values,
        plan_id: planId ? Number(planId) : null,
      });

      if (result?.redirected) {
        keepLoading = true;
        return;
      }

      const target =
        planId && Number(planId)
          ? `/auth/verify-email?plan_id=${planId}`
          : "/auth/verify-email";

      await router.push(target);
      toast("Account created. Verify your email to continue.");
    } catch (e) {
      // errors handled by store
    } finally {
      if (!keepLoading) {
        loading.value = false;
      }
    }
  };

  return { submit, loading };
}
